/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header } from './layouts';
import { slider, tabs, accordion, fancyboxGallery } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  fancyboxGallery.init();


  // Page Modules
}());
